module.exports = {
	"id": "TO",
	"name": "Tonga",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.015164,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": 0.007582,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.007582,
			"31": 0.007582,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.030328,
			"37": null,
			"38": 0.015164,
			"39": null,
			"40": 0.045492,
			"41": 0.11373,
			"42": 0.015164,
			"43": 0.090984,
			"44": 0.015164,
			"45": 0.060656,
			"46": null,
			"47": 0.030328,
			"48": 0.022746,
			"49": 0.659634,
			"50": 0.144058,
			"51": 0.310862,
			"52": 0.22746,
			"53": 19.318936,
			"54": 4.70084,
			"55": 0.022746,
			"56": 0.030328,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.022746,
			"4": 0.022746,
			"5": null,
			"6": 0.022746,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.015164,
			"13": null,
			"14": 0.030328,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.015164,
			"19": null,
			"20": null,
			"21": 0.007582,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.098566,
			"30": 0.015164,
			"31": 0.007582,
			"32": 0.030328,
			"33": null,
			"34": 0.022746,
			"35": 0.212296,
			"36": null,
			"37": 0.015164,
			"38": 0.060656,
			"39": 0.083402,
			"40": 0.068238,
			"41": 0.045492,
			"42": 0.030328,
			"43": 0.523158,
			"44": 0.22746,
			"45": 0.015164,
			"46": 0.07582,
			"47": 0.894676,
			"48": 1.55431,
			"49": 30.009556,
			"50": 2.835668,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.007582
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": null,
			"39": 0.022746,
			"40": 0.068238,
			"41": 0.015164,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.015164
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.022746,
			"6": 0.030328,
			"7": 0.159222,
			"8": 0.197132,
			"9": 0.204714,
			"10": 0.15164,
			"3.1": null,
			"3.2": null,
			"5.1": 0.060656,
			"6.1": 0.03791,
			"7.1": null,
			"9.1": 0.41701
		},
		"ios_saf": {
			"8": 0,
			"10": 2.64800595837,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0713606965029,
			"8.1-8.4": 0.131835863031,
			"9.0-9.2": 0.062894173189,
			"9.3": 0.959539308909
		},
		"android": {
			"3": 0,
			"4": 0.0422056589147,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00527570736434,
			"4.1": 0.152241841085,
			"4.2-4.3": 0.380604602713,
			"4.4": 0.872752732558,
			"4.4.3-4.4.4": 0.880289457364
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 3.69456873786,
			"9": 0.0231876699029,
			"10": 0.200959805825,
			"11": 2.45016378641,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0251795031025,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000699430641736
		},
		"edge": {
			"12": 0.288116,
			"13": 0.765782,
			"14": 0.636888
		},
		"ie_mob": {
			"10": 0.175458253521,
			"11": 0.714365746479
		},
		"bb": {
			"7": 0.001209,
			"10": null
		},
		"samsung": {
			"0": 2.86533
		},
		"and_uc": {
			"0": 1.23318
		},
		"op_mini": {
			"0": 0.339239066256
		},
		"and_chr": {
			"0": 15.05595
		},
		"and_ff": {
			"0": 0.016926
		}
	},
	"total": 98.959241
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/TO.json
 ** module id = 664
 ** module chunks = 0
 **/